import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { AbstractPolyShapeService } from '../abstract-polyshape.service';
import { TrainingPolygonHelper } from './training-polygon-helper';

@Injectable()
export class TrainingPolygonService extends AbstractPolyShapeService<TrainingPolygonHelper> {
  protected override shapeStore =
    this.renderStore('trainingShapes')('polygons');

  constructor() {
    super();
    this.setUpSubscriptions();
  }

  protected override setUpSubscriptions() {
    this.subscribeTo(
      combineLatest([this.shapeStore.$, this.renderStore('frameNumber').$]),
      ([shapes, frameNumber]) => {
        this.updateShapes(shapes, frameNumber);
      },
    );
  }

  protected override createHelper(index: number) {
    return new TrainingPolygonHelper(index);
  }
}
